import { render, staticRenderFns } from "./Booster.vue?vue&type=template&id=7dd05457&scoped=true"
import script from "./Booster.vue?vue&type=script&lang=js"
export * from "./Booster.vue?vue&type=script&lang=js"
import style0 from "./Booster.vue?vue&type=style&index=0&id=7dd05457&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd05457",
  null
  
)

export default component.exports